import module from 'viaticos/module.js'

export class ViaticosCatalgosPagadoraCuentasBancariasService {
  constructor ($http) {
    this.$http = $http
  }

  get (idEmpresa, tipo_moneda) {
    return this.$http.get('/api/viaticos/catalogos/pagadora/cuentasbancarias', {
      params: {
        id_empresa: idEmpresa,
        tipo_moneda: tipo_moneda ? tipo_moneda : '1',
      },
    })
  }
}

module.service('ViaticosCatalgosPagadoraCuentasBancariasService', ViaticosCatalgosPagadoraCuentasBancariasService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Catalogos/Pagadora/CuentasBancarias.js